import { Utilities as utilities } from '@truckdown/framework';

export class ClaimsModel {
    constructor(json?: any) {
        if (json) {
            this.issuer = utilities.json.getStringValue(json, 'iss', '');
            this.originalIssuer = utilities.json.getStringValue(json, 'oiss', '');

            this.properties = utilities.json.getObjectValue<{ [key: string]: string; }>(json, (data) => {
                if (!data || data === null) {
                    return {};
                }
                return data as { [key: string]: string; };
            }, 'props', {});

            this.type = utilities.json.getStringValue(json, 'type', '');
            this.value = utilities.json.getStringValue(json, 'val', '');
            this.valueType = utilities.json.getStringValue(json, 'vtype', '');
        }
    }

    issuer: string = '';
    originalIssuer: string = '';
    properties: { [key: string]: string; } = {};
    type: string = '';
    value: string = '';
    valueType: string = '';
}